module.exports = __webpack_public_path__ + "img/logo-header.c10c502b.png";